import { createFileRoute } from "@tanstack/react-router";
import { SchoolsPage } from "@/components/schools/SchoolsPage";
import { schoolsHead } from "@/components/schools/schools-head";

// Страница «Школам» (ru) — программы для школ, FAQ и форма заявки школы (30.10.2026).
export const Route = createFileRoute("/ru/shkolam")({
  head: () => schoolsHead("ru"),
  component: () => <SchoolsPage lang="ru" />,
});
